import { Component, inject } from '@angular/core';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { TranslateDirective } from '../../../../../../directives/translate.directive';
import { NgIf } from '@angular/common';
import { BaryButtonComponent } from '../../../bary-button/bary-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { BarySortableListComponent } from '../../../bary-sortable-list/bary-sortable-list.component';

@Component({
  selector: 'jhi-modal-change-order',
  templateUrl: './modal-change-order.component.html',
  styleUrls: ['./modal-change-order.component.scss'],
  standalone: true,
  imports: [TranslateDirective, NgIf, BaryButtonComponent, TranslateModule, BarySortableListComponent],
})
export class ModalChangeOrderComponent {
  protected modalRef = inject(MDBModalRef);

  public model!: any[];
  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  public labelField = 'id';

  public handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  public handleSubmit(): void {
    this.action.next(new BaryModalEvent({ submit: true, value: this.model }));
    this.modalRef.hide();
  }
}
